export const visit = (vm, at) => {
at({ "pt-br": { "conversations-visitor-experience-components": { "code-splitting": { "error": { "title": "Ocorreu um problema de conex\xE3o de rede.", "message": "Verifique sua conex\xE3o e tente novamente.", "button": "Tentar novamente" } } } } });
};